/**
 * Moved to `shared/src/review/review-queue.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  buildReviewQueue,
  claimedGap,
  dashboardPageMovement,
  dashboardSiteClicksTile,
  dashboardTrafficLost,
  newlyClaimedUrlIds,
  nextReviewIndex,
  reviewBeltPackages,
  reviewFillPackages,
  reviewOutcome,
  reviewProgress,
  reviewPeriodSearchConsoleNote,
  reviewShowsPeriodChange,
  searchConsoleIsOn,
  searchConsoleUnmeasuredSentence
} from '@taptimize/shared/dist/review/review-queue';
export type {
  BuildReviewQueueOptions,
  DashboardHeaderTile,
  DashboardPageMovement,
  ReviewQueueEntry
} from '@taptimize/shared/dist/review/review-queue';
